import config from './config.js'
//import * as d3 from 'd3';
//import {
//  roundTo20,
//} from '../../node_modules/flowchart-vue/src/utils/math';

export default {

  // active view selection for list
  viewparams: {"start":0,"count":20},

  listusertrigger: function(ctrl,userid,cb) {
    config.get(ctrl,config.baseUrl + 'rest/bflows/user/startlist?userid=' + encodeURIComponent(userid),'Benutzer Trigger laden',cb);
  },

  listrunning: function() {
    return fetch(config.baseUrl + 'rest/bflows/runflow/').then(resp => resp.json());
  },

  usertrigger: function(ctrl, eid, params,cb) {
    config.post(ctrl,config.baseUrl + 'rest/bflows/user/trigger/' + encodeURIComponent(eid),'Benutzer Event auslösen',JSON.stringify(params),cb);
  },

  // list the current selected business BusinessFlows
  list: function(cb_success) {
    console.log('list bflows');
    var u = config.baseUrl + 'rest/bflows/definitions?start=' + this.viewparams.start + '&count=' + this.viewparams.count;
    fetch(u,{credentials: 'include'}).then(resp => resp.json()).then(function(data) {
      cb_success(data);
    });
  },

  // get a event map overview
  eventmap: function(cb_success) {
    fetch(config.baseUrl + 'rest/bflows/eventsmap',{credentials: 'include'}).then(resp => resp.json()).then(cb_success);
  },

  listbaseevents: function(ctrl,type,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/bflows/baseevents?start=0&count=100&type=' + encodeURIComponent(type),type + ' Events laden',cb_success);
  },

  savebaseevent: function(ctrl,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/bflows/baseevents','Event speichern',JSON.stringify(data),cb_success);
  },

  deletebaseevent: function(ctrl,id,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/bflows/baseevents/' + encodeURIComponent(id),'Event löschen',cb_success);
  },

  load: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/bflows/definitions/' + encodeURIComponent(id),'BFlow speichern.',cb_success);
  },

  delete: function(ctrl,id,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/bflows/definitions/' + encodeURIComponent(id),'BFlow löschen.',cb_success);
  },

  save: function(ctrl,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/bflows/definitions','BFlow speichern.',JSON.stringify(data),cb_success);
  },

  execute: function(ctrl,id,params,cb) {
    config.post(ctrl,config.baseUrl + 'rest/bflows/runflow/' + encodeURIComponent(id),'BFlow ausführen',JSON.stringify(params),cb);
  },

  // renderTask: function(g,node,isSelected) {
  //   let borderColor = isSelected ? '#666666' : '#bbbbbb';
  //   // title
  //   g.append('rect').attr('x', node.x).attr('y', node.y).
  //       attr('class', 'title').
  //       attr('stroke', borderColor).
  //       style('width', node.width + 'px').style('height', '20px');
  //   g.append('text').attr('x', node.x + 4).attr('y', node.y + 15).
  //       attr('class', 'unselectable').
  //       text(() => node.type).
  //       each(function wrap() {
  //         let self = d3.select(this),
  //             textLength = self.node().getComputedTextLength(),
  //             text = self.text();
  //         while (textLength > (node.width - 2 * 4) && text.length > 0) {
  //           text = text.slice(0, -1);
  //           self.text(text + '...');
  //           textLength = self.node().getComputedTextLength();
  //         }
  //       });
  //   // body
  //   let body = g.append('rect').attr('class', 'body');
  //   body.style('width', node.width + 'px');
  //   body.attr('x', node.x).attr('y', node.y + 20);
  //   body.style('height', roundTo20(node.height - 20) + 'px');
  //   body.attr('stroke', borderColor);
  //   // body text
  //   let text = node.name;
  //   let bodyTextY;
  //   bodyTextY = node.y + 25 + roundTo20(node.height - 20) / 2;
  //   g.append('text').attr('x', node.x + node.width / 2).attr('y', bodyTextY).
  //       attr('class', 'unselectable').
  //       attr('text-anchor', 'middle').
  //       text(function() {return text;}).each(function wrap() {
  //     let self = d3.select(this),
  //         textLength = self.node().getComputedTextLength(),
  //         text = self.text();
  //     while (textLength > (node.width - 2 * 4) && text.length > 0) {
  //       text = text.slice(0, -1);
  //       self.text(text + '...');
  //       textLength = self.node().getComputedTextLength();
  //     }
  //   });
  // },
  //
  // renderEvent: function(g,node,isSelected) {
  //   let borderColor = isSelected ? '#666666' : '#bbbbbb';
  //   // body
  //   let body = g.append('rect').attr('class', 'eventstart');
  //   body.style('width', node.width + 'px');
  //   body.attr('x', node.x).attr('y', node.y).classed(node.type, true).attr('rx', 30);
  //   body.style('height', roundTo20(node.height) + 'px');
  //   body.attr('stroke', borderColor);
  //   // body text
  //   let text = node.name;
  //   let bodyTextY;
  //   bodyTextY = node.y + 5 + roundTo20(node.height) / 2;
  //   g.append('text').attr('x', node.x + node.width / 2).attr('y', bodyTextY).
  //       attr('class', 'unselectable').
  //       attr('text-anchor', 'middle').
  //       text(function() {return text;}).each(function wrap() {
  //     let self = d3.select(this),
  //         textLength = self.node().getComputedTextLength(),
  //         text = self.text();
  //     while (textLength > (node.width - 2 * 4) && text.length > 0) {
  //       text = text.slice(0, -1);
  //       self.text(text + '...');
  //       textLength = self.node().getComputedTextLength();
  //     }
  //   });
  // }

}
